var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.pageClass],attrs:{"id":"map"}},[_c('div',{staticClass:"map-button"})])}
var staticRenderFns = []

export { render, staticRenderFns }